import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthLayout } from "@/layouts/AuthLayout";
import { Turnstile } from "@/components/ui/Turnstile";
import { ForgotPasswordModal } from "@/components/account/ForgotPasswordModal";
import { useAuth } from "@/hooks/useAuth";
import { useAuthConfig } from "@/hooks/useAuthConfig";

export function LoginPage() {
  const { login } = useAuth();
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);

  const needsCaptcha = !!cfg?.captcha_sitekey;
  const canSubmit = u.length > 0 && p.length > 0 && (!needsCaptcha || captcha.length > 0) && !busy;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try { await login(u, p, captcha || undefined); nav("/", { replace: true }); }
    catch (ex) {
      const msg = ex instanceof Error ? ex.message : "Identifiants invalides";
      setErr(msg.replace(/^api\s+/i, ""));
    }
    finally { setBusy(false); }
  };

  const inputStyle = { padding: 12, background: "var(--bg-elev-2)",
                       border: "1px solid var(--line)", borderRadius: 8, color: "var(--fg)" };

  return (
    <AuthLayout>
      <h1 style={{ marginTop: 0 }}>sonslow</h1>
      <form onSubmit={submit} className="stack" style={{ gap: 12 }}>
        <input placeholder="Nom d'utilisateur" value={u} onChange={(e) => setU(e.target.value)}
               required autoComplete="username" style={inputStyle} />
        <input type="password" placeholder="Mot de passe" value={p} onChange={(e) => setP(e.target.value)}
               required autoComplete="current-password" style={inputStyle} />
        {needsCaptcha && cfg?.captcha_sitekey && (
          <Turnstile sitekey={cfg.captcha_sitekey} onToken={setCaptcha} theme="dark" />
        )}
        {err && <div style={{ color: "#f87171" }}>{err}</div>}
        <button type="submit" className="btn primary" disabled={!canSubmit}>
          {busy ? "…" : "Se connecter"}
        </button>
        <div className="muted" style={{ marginTop: 6, display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
          <button type="button" onClick={() => setForgotOpen(true)}
                  style={{ background: "transparent", color: "var(--fg-mute)", padding: 0,
                           textDecoration: "underline", cursor: "pointer" }}>
            Mot de passe oublié ?
          </button>
          <span>Pas encore de compte ? <Link to="/register">S'inscrire</Link></span>
        </div>
      </form>
      <ForgotPasswordModal open={forgotOpen} onClose={() => setForgotOpen(false)} />
    </AuthLayout>
  );
}
